import React from 'react'
import PropTypes from 'prop-types'

import Preloader from '../preloader'

class FontPreviewImageComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = { error: false, isLoading: true }
  }

  render () {
    const { endpoint, filename, itemId, text, version } = this.props
    const { isLoading, error } = this.state

    let uriParams = `text=${encodeURIComponent(text)}&version=${encodeURIComponent(version)}`
    let heading
    if (filename) {
      heading = <p className='t-body -weight-bold'>{filename}</p>
      uriParams += `&filename=${encodeURIComponent(filename)}`
    }

    let image
    if (!error) {
      image = <img
        onError={this._handleError.bind(this)}
        onLoad={this._handleLoad.bind(this)}
        src={`${endpoint}/preview/${itemId}?${uriParams}`}
      />
    } else {
      image = <div>Something went wrong, please try again.</div>
    }

    return (
      <div className='h-mb1 h-mt1' style={{ overflowX: 'hidden' }}>
        {heading}
        <Preloader isLoading={isLoading} />
        {image}
      </div>
    )
  }

  _handleLoad () {
    this.setState({ isLoading: false })
  }

  _handleError () {
    this.setState({ error: true, isLoading: false })
  }
}

FontPreviewImageComponent.propTypes = {
  endpoint: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  filename: PropTypes.string
}

export default FontPreviewImageComponent
